import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CurrentLanguage from '@/components/CurrentLanguage.vue';
import {
  Co2BasketValue,
  Co2QuizQuestion,
  titleRules,
} from '@/models/co2-quiz.model';
import { useEvents, Event } from '@/services/events.composable';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { NEW_ID } from '@/util/constants';
import { computed, onMounted, PropType, ref, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import {
  Co2QuizStoreActions,
  Co2QuizStoreState,
} from '@/stores/co2-quiz.store';
import { countries } from '@/models/country.model';
import CategoriesField from '@/components/categories/CategoriesField.vue';
import { LabelsState } from '@/stores/labels.store';
import { UserLabel } from '@/models/label.model';
import RichTextField from '@/components/common/RichTextField.vue';
import LinksField from '@/components/common/LinksField.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Co2ValueForm',
  props: {
  data: {
    type: Object as PropType<Co2BasketValue>,
  },
},
  setup(__props) {

const store = useStore<
  ShiftCMSState & { co2: Co2QuizStoreState; ls: LabelsState }
>();
const questions = computed<Co2QuizQuestion[]>(() => store.state.co2.questions);
const labels = computed<UserLabel[]>(() => store.state.ls.labels);
const events = useEvents();

const props = __props;

const valid = ref<boolean>(false);

const value = ref<Co2BasketValue>({
  id: NEW_ID,
  value: 0,
  description: '',
  sources: [],
  country: 'NL',
  overrideQuestions: [],
  notRelevantForlabels: [],
  categories: [],
  ...(props.data || {}),
});

const action = computed<string>(() =>
  value.value.id === NEW_ID ? 'Add' : 'Save',
);

const saveCo2BasketValue = async () => {
  let success: boolean = false;
  if (valid.value) {
    if (value.value.id === NEW_ID) {
      success = await store.dispatch(
        Co2QuizStoreActions.AddCo2BasketValue,
        value.value,
      );
    } else {
      success = await store.dispatch(
        Co2QuizStoreActions.UpdateCo2BasketValue,
        value.value,
      );
    }
  }
  if (success) {
    events.emit(Event.Saved, true);
    store.dispatch(Actions.ShowNotification, {
      message: 'Saved value',
      type: 'success',
    });
    store.commit(Mutations.HideDrawer);
    store.dispatch(Co2QuizStoreActions.GetCo2Values);
  }
};

const updateLanguage = async () => {
  if (value.value.id === NEW_ID) {
    Object.assign(value.value, { title: '', type: 'value' });
  } else {
    const q = await store.dispatch(
      Co2QuizStoreActions.GetCo2Value,
      value.value.id,
    );

    if (q) {
      Object.assign(value.value, { ...q });
    }
  }
};

onMounted(() => {
  events.on(Event.LanguageChanged, updateLanguage);
  if (props.data) {
    Object.assign(value.value, props.data);
  }
});

onBeforeUnmount(() => {
  events.off(Event.LanguageChanged, updateLanguage);
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: valid.value,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((valid).value = $event)),
    onSubmit: _withModifiers(saveCo2BasketValue, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, [
            _createTextVNode(_toDisplayString(_ctx.$t(action.value)) + " a value ", 1),
            _createVNode(CurrentLanguage)
          ]),
          _createVNode(CategoriesField, {
            class: "mt-8",
            modelValue: value.value.categories,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value.value.categories) = $event)),
            max: 1
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_text_field, {
            modelValue: value.value.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value.value.value) = $event)),
            rules: _unref(titleRules),
            label: "Value",
            required: ""
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_v_autocomplete, {
            modelValue: value.value.country,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((value.value.country) = $event)),
            items: _unref(countries),
            label: "Country",
            "item-title": "text",
            "item-value": "value",
            "hide-details": true
          }, null, 8, ["modelValue", "items"]),
          _createVNode(_component_v_select, {
            modelValue: value.value.overrideQuestions,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((value.value.overrideQuestions) = $event)),
            label: "Override questions",
            multiple: "",
            class: "mt-8 mb-8",
            "hide-details": "auto",
            style: { background: 'white' },
            items: questions.value.map((q) => ({ title: q.title, value: q }))
          }, {
            item: _withCtx(({ props }) => [
              _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title)
                ]),
                _: 2
              }, 1040)
            ]),
            _: 1
          }, 8, ["modelValue", "items"]),
          _createVNode(_component_v_select, {
            modelValue: value.value.notRelevantForlabels,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((value.value.notRelevantForlabels) = $event)),
            label: "Not relevant for labels",
            multiple: "",
            clearable: "",
            class: "mt-4",
            "hide-details": "auto",
            style: { background: 'white' },
            items: labels.value.map((q) => ({ title: q.value, value: q }))
          }, {
            item: _withCtx(({ props }) => [
              _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title)
                ]),
                _: 2
              }, 1040)
            ]),
            _: 1
          }, 8, ["modelValue", "items"]),
          _cache[9] || (_cache[9] = _createElementVNode("h3", null, "Read more", -1)),
          _createVNode(RichTextField, {
            label: "Description",
            height: 200,
            modelValue: value.value.description,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((value.value.description) = $event)),
            media: []
          }, null, 8, ["modelValue"]),
          _createVNode(LinksField, {
            modelValue: value.value.sources,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((value.value.sources) = $event)),
            label: "Source"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { col: "2" }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "reset",
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("Reset")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "submit",
                    color: "success",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(action.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { col: "2" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})